import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActAutomaticaLlavesConfigComponent } from './act-automatica-llaves-config.component';
import { ActAutoCamposTextoConfigComponent } from './act-auto-campos-texto-config.component';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { CustomTitle, FormGroupErrorMessageComponent } from 'lib-base';
import { TranslateModule } from '@ngx-translate/core';
import { IGetReporteLogos, ITipoTramite, ITipoTramiteActividad, TipoTramiteActividaAutomaticoDto } from '../../../../shared/interfaces/database/configuracion';
import { ReporteLogoService } from '../../../../services/database/reporteLogo.service';
import { MultiSelectChangeEvent, MultiSelectModule } from 'primeng/multiselect';
import { IColumnDinamico, IGetNombreColumnas, TablasDinamicasConfig } from '../../../../shared/interfaces/database/tramites_automaticos';
import { TablasDinamicasConfigService } from '../../../../services/database/tablas-dinamicas-config.service';
import { FormularioService } from '../../../../services/database/formulario.service';
import { PanelModule } from 'primeng/panel';

@Component({
  selector: 'app-actividad-automatica',
  standalone: true,
  imports: [ActAutomaticaLlavesConfigComponent, ActAutoCamposTextoConfigComponent, CommonModule, 
    ReactiveFormsModule, FormsModule, DropdownModule, 
    FormGroupErrorMessageComponent, TranslateModule, MultiSelectModule, 
    TranslateModule, PanelModule 
  ],
  template: `
  <p-panel [header]="'msg.configuraciónActividadAutomática' | translate" class="w-full">
    <main class="grid formgrid p-fluid" [formGroup]="form">
      <div class="field col-12 md:col-6">
        <label for="tablaDinamicaConfigId" class="ml-3">
          {{'fields.tipo-tramite-actividad.tablaDinamica' | translate}}
          <span style="color: red">*</span>
        </label>
        <div class="flex gap-1 justify-content-start">
          <p-dropdown [options]="tablasDinamicas" formControlName="tablaDinamicaConfigId" appendTo="body"
            placeholder="Select" optionLabel="datasetNombre" optionValue="id"
            autoWidth="false" class="flex-grow-1" (onChange)="onChangeTablaDinamica($event)">
          </p-dropdown>
        </div>
        <ng-container
          *ngIf="form.get('tablaDinamicaConfigId')?.invalid && form.get('tablaDinamicaConfigId')?.dirty">
          <app-form-group-error-message
            [control]="form.get('tablaDinamicaConfigId')"></app-form-group-error-message>
        </ng-container>
      </div>
      <div class="field col-12 md:col-6">
        <label for="columnasVisibles" class="ml-3">
          {{'fields.tipo-tramite-actividad.columnasVisibles' | translate}}
          <span style="color: red">*</span>
        </label>
        <div class="flex gap-1 justify-content-start">
          <p-multiSelect [options]="columnsTablaDinamica" formControlName="columnasVisibles" appendTo="body"
            placeholder="Select" optionLabel="displayName" optionValue="name" (onChange)="onChangeColumnasVisibles($event)"
            autoWidth="false" class="flex-grow-1">
          </p-multiSelect>
        </div>
        <ng-container
          *ngIf="form.get('columnasVisibles')?.invalid && form.get('columnasVisibles')?.dirty">
          <app-form-group-error-message
            [control]="form.get('columnasVisibles')"></app-form-group-error-message>
        </ng-container>
      </div>
      <div class="field col-12 md:col-6">
        <label for="reporteLogoId" class="ml-3">
          {{'common.reporteLogo' | translate}}
          <span style="color: red">*</span>
        </label>
        <div class="flex gap-1 justify-content-start">
          <p-dropdown [options]="reporteLogos" formControlName="reporteLogoId" appendTo="body"
            placeholder="Select" optionLabel="nombre" optionValue="id"
            autoWidth="false" class="flex-grow-1">
          </p-dropdown>
        </div>
        <ng-container
          *ngIf="form.get('reporteLogoId')?.invalid && form.get('reporteLogoId')?.dirty">
          <app-form-group-error-message
            [control]="form.get('reporteLogoId')"></app-form-group-error-message>
        </ng-container>
      </div>
  
      @if(columnsTablaDinamica){						
        <div class="field col-12">
          <app-act-automatica-llaves-config 
            [formularioColumnas]="formularioColumnas" 
            [columnsTablaDinamica]="columnsTablaDinamica">
          </app-act-automatica-llaves-config>
        </div>
      }
      <div class="field col-12">
        <app-act-auto-campos-texto-config></app-act-auto-campos-texto-config>
      </div>
    </main>
  </p-panel>
  `
})
export class ActividadAutomaticaComponent implements OnInit {
  @Input() tipoTramite !: ITipoTramite;
  @Input() editActividad !: ITipoTramiteActividad | undefined;
  @Input() parentForm !: FormGroup;
  form !: FormGroup;

  reporteLogos !: IGetReporteLogos[];
  private _formularioColumnas !: IGetNombreColumnas[];
  tablasDinamicas !: TablasDinamicasConfig[];

  private _columnsTablaDinamica: IColumnDinamico[] = [];

  @ViewChild(ActAutoCamposTextoConfigComponent) camposTextoComponent !: ActAutoCamposTextoConfigComponent;
  @ViewChild(ActAutomaticaLlavesConfigComponent) actAutomaticaLlavesConfigComponent!: ActAutomaticaLlavesConfigComponent;

  get columnsTablaDinamica(): IColumnDinamico[] {
    return this._columnsTablaDinamica;
  }

  set columnsTablaDinamica(value: IColumnDinamico[]) {
    if (value == null) {
      this._columnsTablaDinamica = [];
      return;
    }
    this._columnsTablaDinamica = value;
  }

  get formularioColumnas(): IGetNombreColumnas[] {
    return this._formularioColumnas;
  }

  set formularioColumnas(formularioId: number) {
    this._fs.getNombreColumnas(formularioId).subscribe({
      next: (data: IGetNombreColumnas[]) => {
        this._formularioColumnas = data;
        setTimeout(() => {          
          this.actAutomaticaLlavesConfigComponent.load(this.editActividad?.llavesConfig ?? []);
        }, 1);
      }
    });
  }

  constructor(private readonly _rls: ReporteLogoService, private readonly _fb: FormBuilder, private readonly _fs: FormularioService, private readonly _tdc: TablasDinamicasConfigService) {
  }

  ngOnInit(): void {
    this.configurarForm();
    this.getTablasDinamicas();
    this.getReporteLogos();
  }

  configurarForm() {
    this.form = this._fb.group({
      tablaDinamicaConfigId: [this.editActividad?.tablaDinamicaConfigId ?? null, [Validators.required]],
      columnasVisibles: [this.editActividad?.columnasVisibles ?? [], [Validators.required]],
      reporteLogoId: [this.editActividad?.reporteLogoId ?? null, [Validators.required]],
    });
    this.formularioColumnas = this.tipoTramite.formularioId;

    setTimeout(() => {
      this.parentForm.addControl('automatica', this.form);
      this.camposTextoComponent.load(this.editActividad?.camposTexto ?? []);
    });
  }

  initialize() {
    this.camposTextoComponent.updateVariablesFormulario(this.formularioColumnas);

    const columnasVisibles = this.editActividad?.columnasVisibles;
    if (columnasVisibles) {
      const selected = this.columnsTablaDinamica.filter(c => columnasVisibles.includes(c.name));
      this.camposTextoComponent.updateVariablesTabla(selected);
    }
  }

  onChangeTablaDinamica(event: DropdownChangeEvent) {
    const columns: IColumnDinamico[] = this.tablasDinamicas.find(t => t.id === event.value)?.datasetColumnas ?? [];
    this.columnsTablaDinamica = columns;
    this.form.get('columnasVisibles')?.setValue([]);
  }

  onChangeColumnasVisibles($event: MultiSelectChangeEvent) {
    const selected = this.columnsTablaDinamica.filter(c => $event.value.includes(c.name));
    this.camposTextoComponent.updateVariablesTabla(selected);
  }

  getReporteLogos() {
    this._rls.getReporteLogos().subscribe({
      next: (data: IGetReporteLogos[]) => {
        this.reporteLogos = data;
      },
    });
  }

  private getTablasDinamicas() {
    this._tdc.getTablasDinamicas().subscribe({
      next: (data: TablasDinamicasConfig[]) => {
        this.tablasDinamicas = data;
        const columns: IColumnDinamico[] = this.tablasDinamicas.find(t => t.id === this.editActividad?.tablaDinamicaConfigId)?.datasetColumnas ?? [];
        this.columnsTablaDinamica = columns
        this.form.get("tablaDinamicaConfigId")?.setValue(this.editActividad?.tablaDinamicaConfigId ?? null);
      }
    });
  }

  isValid(): boolean {
    const llavesConfigisValid = this.actAutomaticaLlavesConfigComponent.isValid();
    if (!llavesConfigisValid) {
      return false;
    }
    return true;
  }

  getValues(): TipoTramiteActividaAutomaticoDto{
    let values = {
      tablaDinamicaConfigId: this.form.get('tablaDinamicaConfigId')?.value,
      columnasVisibles: this.form.get('columnasVisibles')?.value,
      llavesConfig: this.actAutomaticaLlavesConfigComponent?.llavesConfig ?? [],
      reporteLogoId: this.form.get('reporteLogoId')?.value,
      camposTexto: this.camposTextoComponent?.campos ?? []
    } as TipoTramiteActividaAutomaticoDto;

    return values;
  }
}
